"use client";

import React, { useState } from "react";
import { Box, CallToAction, Dialog, Grid2, Typography } from "@repo/ui";
import Section from "../components/Section/Section";
import Image from "next/image";
import CompanyLogoCard from "../components/CompanyLogoCard";
import { hasData } from "@/lib/helpers";
import DownloadBrochureForm from "@/components/forms/DownloadBrochureForm";
import { useParams } from "next/navigation";
import Link from "next/link";

type BannerProps = {
  sectionInfo: PageSections;
  data: {
    heading: string;
    paragraph: string;
    imageAltText: string;
    bannerImage: string;
    backgroundBannerImage?: string;
    categories: {
      categoryName: string;
    }[];
  };
};

const Banner = ({ data, sectionInfo }: BannerProps) => {
  const [open, setOpen] = useState(false);

  const { country: countryParam } = useParams<{ country: string }>();

  if (!hasData(data)) return null;
  return (
    <Section
      id={sectionInfo.sectionId}
      className={sectionInfo.sectionClass}
      bgImage={data.backgroundBannerImage}
      bgImageProps={{ className: "hidden sm:block" }}
    >
      <Grid2 container spacing={2} className="items-center">
        <Grid2 item size={{ sm: 12, md: 7, lg: 7, xl: 7 }}>
          <Typography
            gutterBottom
            variant="h1"
            className="!leading-snug tracking-wide"
            forceVariant
          >
            {data.heading}
          </Typography>

          <Typography
            paragraph
            variant="subtitle2"
            className="gray-text text-xl"
          >
            {data.paragraph}
          </Typography>
          <Box mt="sm">
            <CallToAction
              isResponsive
              size="large"
              onSaveLabel="Explore courses"
              onCancelLabel="Download Brochure"
              onCancel={() => setOpen(true)}
              onSaveRender={
                <Link
                  href={`/${countryParam ? `${countryParam}/courses` : "courses"}`}
                />
              }
            />
          </Box>
        </Grid2>
        <Grid2
          item
          size={{ sm: 12, md: 5, lg: 5, xl: 5 }}
          className="relative hidden sm:block min-h-[350px]"
        >
          {data.bannerImage && !data.backgroundBannerImage && (
            <Image
              src={data.bannerImage}
              alt={data.imageAltText}
              width={372}
              height={300}
              className="w-full h-auto rounded-2xl"
              priority
              quality={100}
            />
          )}
        </Grid2>
      </Grid2>
      {/* Download brochure popup  */}
      <Dialog className="!p-0" open={open} onOpenChange={setOpen} maxWidth="md">
        <DownloadBrochureForm />
      </Dialog>
      {/* Below card is  Only for Home banner */}
      <CompanyLogoCard className="bg-white/75" />
    </Section>
  );
};

export default Banner;
